export function SpotifyGetAuthUri() {
  return (
    'https://accounts.spotify.com/authorize' +
    '?client_id=' +
    '7375dad704cf4c78845092a494779ff2' +
    '&redirect_uri=' +
    encodeURIComponent(
      window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname
    ) +
    '&response_type=token&show_dialog=true&scope=user-top-read%20user-read-birthdate'
  )
}

function getHashParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec('?' + location.hash.substring(1))
  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

export function SpotifyAuthUser() {
  return getHashParameter('access_token')
}

export function SpotifyGetUserAge(app) {
  return fetch('https://api.spotify.com/v1/me/', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json; charset=utf-8',
      Authorization: 'Bearer ' + app.user.accessToken
    }
  })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw data.error
      }
      console.log('Successfully got age.')

      app.user.age = Math.floor(
        (Date.now() - Date.parse(data.birthdate)) / (1000 * 60 * 60 * 24 * 365)
      )
      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to get age.')
      console.log(error)
      throw error
    })
}

export function SpotifyGetTop50Tracks(app) {
  // now actually 99 tracks
  return Promise.all([
    fetch(
      'https://api.spotify.com/v1/me/top/tracks?time_range=medium_term&offset=0&limit=49',
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + app.user.accessToken
        }
      }
    ).catch(error => {
      console.log('Failed fetch.')
      console.log(error)
      throw error
    }),
    fetch(
      'https://api.spotify.com/v1/me/top/tracks?time_range=medium_term&offset=49&limit=50',
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: 'Bearer ' + app.user.accessToken
        }
      }
    ).catch(error => {
      console.log('Failed fetch.')
      console.log(error)
      throw error
    })
  ])
    .then(response => Promise.all(response.map(v => v.json())))
    .then(data => {
      if (data[0].error) {
        throw data[0].error
      }
      if (data[1].error) {
        throw data[1].error
      }
      console.log('Successfully got tracks.')

      const tracks = data[0].items.concat(data[1].items)

      for (let i = 0, len = app.audioFeatures.length; i < len; i++) {
        app.user.featureProfile[app.audioFeatures[i]] = 0
      }

      let trackIds = []

      for (let i = 0, len = tracks.length; i < len; i++) {
        trackIds.push(tracks[i].id)
        app.user.featureProfile.popularity += tracks[i].popularity
      }

      app.user.featureProfile.popularity =
        app.user.featureProfile.popularity / tracks.length
      app.user.topTracks = trackIds

      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to get tracks.')
      console.log(error)
      throw error
    })
}

export function SpotifyGetTracksInfo(app) {
  return fetch(
    'https://api.spotify.com/v1/audio-features/?ids=' +
      encodeURIComponent(app.user.topTracks.join(',')),
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: 'Bearer ' + app.user.accessToken
      }
    }
  )
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        throw data.error
      }
      console.log('Successfully got tracks info.')

      const tracksWithAudioFeatures = data.audio_features

      // Iterate over all audio features (7)
      for (let j = 1, len2 = app.audioFeatures.length; j < len2; j++) {
        let trackCounter = 0
        // Iterate over all tracks (99)
        for (let i = 0, len = tracksWithAudioFeatures.length; i < len; i++) {
          if (app.audioFeatures[j] === 'speechiness') {
            if (tracksWithAudioFeatures[i][app.audioFeatures[j]] < 0.66) {
              app.user.featureProfile[app.audioFeatures[j]] +=
                tracksWithAudioFeatures[i][app.audioFeatures[j]]
              trackCounter++
            }
          } else {
            app.user.featureProfile[app.audioFeatures[j]] +=
              tracksWithAudioFeatures[i][app.audioFeatures[j]]
            trackCounter++
          }
        }
        // Divide by track count
        app.user.featureProfile[app.audioFeatures[j]] =
          app.user.featureProfile[app.audioFeatures[j]] / trackCounter
      }

      return Promise.resolve(app)
    })
    .catch(error => {
      console.log('Failed to get tracks info.')
      console.log(error)
      throw error
    })
}
